import type { ServiceConfig } from './services'

// Единый формат сервиса для авторизации
export const authService: ServiceConfig = {
	layout: () => import('@/components/layout/AuthLayout.vue'),
	actions: {
		'login': () => import('@/views/auth/LoginView.vue'),
		'signup': () => import('@/views/auth/RegisterView.vue'),
		'confirm-email': () => import('@/views/auth/ConfirmEmailView.vue'),
	}
}